import { ITab } from '@/shared/Tabs/tabs.types.ts'
import { IOption } from '@/types/global'

const cardTabs: ITab<TLiftTabId>[] = [
  { title: 'Об объекте', id: 'about' },
  { title: 'Журнал обслуживания', id: 'journals' },
  { title: 'События', id: 'events' },
  { title: 'Аналитика', id: 'analytics' },
  { title: 'Файлы', id: 'files' },
]

const dateOptions: IOption<number>[] = [
  { title: '30 дней', value: 30 },
  { title: '7 дней', value: 7 },
  { title: 'сутки', value: 1 },
]

export type TLiftTabId = 'about' | 'journals' | 'diagnostics' | 'events' | 'analytics' | 'files'

const liftPageConstants = { cardTabs, dateOptions }
export default liftPageConstants
